
    .responsive3839243538__root .CounterBadge3740516708__root {
        --CounterBadge3740516708-color-standard: #116dff;
        --CounterBadge3740516708-color-danger: #ee4437;
    }

/* st-namespace-reference="../../../../src/skins/responsive/CounterBadge.st.css" */